export const bookType = [
  {
    value: "regularbook",
    label: "Regular Book (Standard)",
  },
  {
    value: "largebook",
    label: "Large Book (Non-Standard)",
  },
];

export const documentType = [
  {
    value: "passportbook",
    label: "Passport Book",
  },
  {
    value: "passportcard",
    label: "Passport Card",
  },
  {
    value: "both",
    label: "Both",
  },
  {
    value: "none",
    label: "None",
  },
];

export const passportStatus = [
  {
    value: "yes",
    name: "Yes",
  },
  {
    value: "damaged",
    name: "Yes, but it was Damaged or Mutilated",
  },
  {
    value: "lost",
    name: "No, it was Lost",
  },
  {
    value: "stolen",
    name: "No, it has been Stolen",
  },
];

export const lostType = [
  {
    label: "Lost",
    value: "lost",
  },
  {
    label: "Stolen",
    value: "stolen",
  },
];
